<!--
 * @Autor: yingna.gao
 * @Date: 2022-07-06 19:09:34
 * @LastEditTime: 2022-07-06 19:13:08
 * @LastEditors: yingna.gao
 * @Description: 
 * @FilePath: /scim-edm-web/src/views/standard/home/components/message-notify.vue
-->
<template>
  <el-card class="card-wrapper">
    <div slot="header" class="clearfix">
      <span>消息通知</span>
      <span class="more">更多</span>
    </div>
    <div>
      <div class="message-parent">
        <div class="message-left">
          <div>通知文本内容通知文本内容通知通通知文本内容通知文本内容通知通通知文本内容通知文本内容通知通</div>
          <div>通知文本内容通知文本内容通知通通知文本内容通知文本内容通知通通知文本内容通知文本内容通知通</div>
          <div>通知文本内容通知文本内容通知通通知文本内容通知文本内容通知通通知文本内容通知文本内容通知通</div>
          <div>通知文本内容通知文本内容通知通通知文本内容通知文本内容通知通通知文本内容通知文本内容通知通</div>
        </div>
        <div class="message-right">
          <div>2021.09.29 01:01:04</div>
          <div>2021.09.29 01:01:04</div>
          <div>2021.09.29 01:01:04</div>
          <div>2021.09.29 01:01:04</div>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "MessageNotify"
};
</script>

<style lang="scss" scoped>
.card-wrapper{
    width:100%;
    height:100%;
    &.el-card.is-always-shadow {
  box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.03) !important;
}
&.el-card {
  border: 1px solid #ebecef !important;
}
::v-deep .el-card__body {
    padding: 16px 24px !important;
   }
   ::v-deep .el-card__header {
    padding: 0px 24px !important;
    font-size: 16px !important;
    color: #21252e !important;
    font-weight: 600 !important;
    height: 44px;
    line-height: 44px;
    }
.more {
  float: right;
  font-weight: 400;
}
.message-parent {
  height: 82px;
  width: 100%;
  display: table;
  table-layout: fixed;
  color: #4f5363;
  .message-right,
  .message-left {
    display: table-cell;
  }
  .message-left div,
  .message-right div {
    height: 20px;
    line-height: 20px;
  }
  .message-left div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 16px;
  }

  .message-right {
    width: 30%;
  }
}
}

</style>
